// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bHLy","right":"styles_right__37AcF"};